import "@hotwired/turbo-rails";
import "./controllers"

import "trix"
import "@rails/actiontext"

import { appsignal } from "./appsignal";
import AirDatepicker from "air-datepicker";
import localeEn from "air-datepicker/locale/en";
require("fslightbox");
// require("./trix-upload");

document.addEventListener("trix-before-initialize", (e) => {
  // Turn off the default Trix captions
  if (e.target.classList.contains('trix-no-attachments')) {
    e.target.toolbarElement.querySelector(".trix-button-group--file-tools").remove();
  }

  Trix.config.attachments.preview.caption = {
    name: false,
    size: false
  };
})

// ! Fix for clipboard.js Preline helper
import { initClipboardJS } from "./preline/clipboard-fix"

initCustomScripts = () => {
  console.debug("------- initCustomScripts --------");
  // TODO: Read props from data-attributes
  new AirDatepicker("#survey_expires_on", {
    locale: localeEn,
    firstDay: 1,
    dateFormat: "d.M.yyyy",
    minDate: new Date(),
    // altField: "#survey_expires_on",
    // altFieldDateFormat: "yyyy-mm-dd",
  })
  
  initClipboardJS();

  // Re-initialize Preline
  HSStaticMethods.autoInit();

  // Re-initialize Lightbox
  refreshFsLightbox();

  console.debug("------- // initCustomScripts --------");
}

document.addEventListener('DOMContentLoaded', function () {
  console.log("Welcome to the BPS admin part!");
})

document.addEventListener("turbo:before-visit", () => {
  // console.debug("turbo:before-visit event fired);
})

document.addEventListener("turbo:visit", () => {
  console.debug("turbo:visit event fired");
})

document.addEventListener("turbo:render", () => {
  console.debug("turbo:render event fired");
  // initCustomScripts();
})

document.addEventListener("turbo:load", (event) => {
  console.debug("turbo:load event fired", event);
  initCustomScripts();
});
